import { render, staticRenderFns } from "./EmailRecipientsInputs.vue?vue&type=template&id=1f098e92&scoped=true&"
import script from "./EmailRecipientsInputs.vue?vue&type=script&lang=js&"
export * from "./EmailRecipientsInputs.vue?vue&type=script&lang=js&"
import style0 from "./EmailRecipientsInputs.vue?vue&type=style&index=0&id=1f098e92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f098e92",
  null
  
)

export default component.exports